import { Injectable } from '@angular/core';
import { CreateLiaStatusWizardStepInput,
  CreateOrUpdateProfessionRequirementInput,
  LiaStatusWizardStepDto,
  LiaStatusWizardStepServiceProxy,
  CreateSlapStatusWizardStepInput,
    SlapStatusWizardStepDto,
    SlapStatusWizardStepServiceProxy,
    UpdateSlapStatusWizardStepsInput,

    ProfessionRegisterAffiliationDto,
    ProfessionRegisterAffiliationServiceProxy,
    RequirementAlternativeDto,
    RequirementDto,
    RequirementGroupServiceProxy,
    RequirementServiceProxy,
    RequirementType,
    UpdateLiaStatusWizardStepsInput,

    CreateEhcStatusWizardStepInput,
    EhcStatusWizardStepDto,
    EhcStatusWizardStepServiceProxy,
    AlapStatusWizardStepDto,
    AlapStatusWizardStepServiceProxy,
    CreateAlapStatusWizardStepInput,
    UpdateAlapStatusWizardStepsInput,
    UpdateEhcStatusWizardStepsInput,
    EhcPracticeConfigurationServiceProxy,
    CreateOrUpdateEhcPracticeConfigurationInput,
    EhcPracticeConfigurationDto,
    ApplicationType,
    CreateRequirementGroupDto,
    UpdateRequirementGroupDto,
    GetRequirementGroupDto,
    RequirementGroupDiscriminator} from '@shared/service-proxies/service-proxies';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequirementConfigurationService {

  constructor(private requirementProxy: RequirementServiceProxy,
              private professionRegisterAffiliationProxy: ProfessionRegisterAffiliationServiceProxy,
              private requirementGroupProxy: RequirementGroupServiceProxy,
              private liaStatusWizardStepProxy: LiaStatusWizardStepServiceProxy,
              private ehcStatusWizardStepProxy: EhcStatusWizardStepServiceProxy,
              private alapStatusWizardStepProxy: AlapStatusWizardStepServiceProxy,
              private slapStatusWizardStepProxy: SlapStatusWizardStepServiceProxy,
              private ehcPracticeConfigurationServiceProxy: EhcPracticeConfigurationServiceProxy) {  }


  exportGlobalProfessionConfiguration(): Observable<string> {
    return this.professionRegisterAffiliationProxy.exportGlobalProfessionConfiguration();
  }

  importGlobalProfessionConfiguration(json: string): Observable<void> {
    return this.professionRegisterAffiliationProxy.importGlobalProfessionConfiguration(json);
  }

  getAffiliations(): Observable<ProfessionRegisterAffiliationDto[]> {
    return this.professionRegisterAffiliationProxy.getAll();
  }

  getProfessionAffiliationById(professionId: string): Observable<ProfessionRegisterAffiliationDto> {
    return this.professionRegisterAffiliationProxy.get(professionId);
  }

  updateAffiliation(professionAffiliationDto: ProfessionRegisterAffiliationDto): Observable<void> {
    return this.professionRegisterAffiliationProxy.update(professionAffiliationDto);
  }

  getRequirementGroups(discriminator: RequirementGroupDiscriminator, professionIdOrSponsorshipTypeId: string): Observable<GetRequirementGroupDto[]> {
    return this.requirementGroupProxy.getRequirementGroups(discriminator, professionIdOrSponsorshipTypeId);
  }

  getRequirement(id: number): Observable<RequirementDto> {
    return this.requirementProxy.get(id);
  }

  getRequirementByProfessionAndType(professionId: string, requirementTypeId: RequirementType): Observable<RequirementDto | undefined> {
    return this.requirementProxy.getRequirementByProfessionAndType(professionId, requirementTypeId);
  }

  createOrUpdateRequirement(professionDto: CreateOrUpdateProfessionRequirementInput): Observable<void> {
    return this.requirementProxy.createOrUpdate(professionDto);
  }

  deleteRequirement(id: number): Observable<void> {
    return this.requirementProxy.delete(id);
  }

  getAlternative(alternativeId: number): Observable<RequirementAlternativeDto> {
    return this.requirementGroupProxy.getAlternative(alternativeId);
  }

  createAlternative(groupId: number): Observable<number> {
    return this.requirementGroupProxy.createAlternative(groupId);
  }

  deleteAlternative(alternativeId: number): Observable<void> {
    return this.requirementGroupProxy.deleteAlternative(alternativeId);
  }

  getGroup(groupId: number): Observable<GetRequirementGroupDto> {
    return this.requirementGroupProxy.get(groupId);
  }

  createGroup(group: CreateRequirementGroupDto): Observable<number> {
    return this.requirementGroupProxy.createRequirementGroup(group);
  }

  updateGroup(id: number, group: UpdateRequirementGroupDto): Observable<void> {
    return this.requirementGroupProxy.updateRequirementGroup(id, group);
  }

  deleteGroup(id: number): Observable<void> {
    return this.requirementGroupProxy.delete(id);
  }

  getLiaWizardStepsByProfessionId(professionId: string, applicationType: ApplicationType): Observable<LiaStatusWizardStepDto[]> {
    return this.liaStatusWizardStepProxy.getAllByProfessionId(professionId, applicationType);
  }

  createLiaWizardStep(input: CreateLiaStatusWizardStepInput): Observable<LiaStatusWizardStepDto> {
    return this.liaStatusWizardStepProxy.create(input);
  }

  updateLiaWizardSteps(input: UpdateLiaStatusWizardStepsInput): Observable<void> {
    return this.liaStatusWizardStepProxy.updateMany(input);
  }

  deleteLiaWizardStep(step: number, professionId: string, applicationType: ApplicationType): Observable<void> {
    return this.liaStatusWizardStepProxy.delete(step, professionId, applicationType);
  }

  getEhcWizardStepsByProfessionId(professionId: string, applicationType: ApplicationType): Observable<EhcStatusWizardStepDto[]> {
    return this.ehcStatusWizardStepProxy.getAllByProfessionId(professionId, applicationType);
  }

  createEhcWizardStep(input: CreateEhcStatusWizardStepInput): Observable<EhcStatusWizardStepDto> {
    return this.ehcStatusWizardStepProxy.create(input);
  }

  updateEhcWizardSteps(input: UpdateEhcStatusWizardStepsInput): Observable<void> {
    return this.ehcStatusWizardStepProxy.updateMany(input);
  }

  deleteEhcWizardStep(step: number, professionId: string, applicationType: ApplicationType): Observable<void> {
    return this.ehcStatusWizardStepProxy.delete(step, professionId, applicationType);
  }

  getAlapWizardStepsByProfessionAndApplicationTypeId(professionId: string, applicationType: ApplicationType): Observable<AlapStatusWizardStepDto[]> {
    return this.alapStatusWizardStepProxy.getAllByProfessionId(professionId, applicationType);
  }

  createAlapWizardStep(input: CreateAlapStatusWizardStepInput): Observable<AlapStatusWizardStepDto> {
    return this.alapStatusWizardStepProxy.create(input);
  }

  updateAlapWizardSteps(input: UpdateAlapStatusWizardStepsInput): Observable<void> {
    return this.alapStatusWizardStepProxy.updateMany(input);
  }

  deleteAlapWizardStep(step: number, professionId: string, applicationType: ApplicationType): Observable<void> {
    return this.alapStatusWizardStepProxy.delete(step, professionId, applicationType);
  }

  getSlapWizardStepsByProfessionAndApplicationTypeId(professionId: string, applicationType: ApplicationType): Observable<SlapStatusWizardStepDto[]> {
    return this.slapStatusWizardStepProxy.getAllByProfessionIdAndApplicationType(professionId, applicationType);
  }

  createSlapWizardStep(input: CreateSlapStatusWizardStepInput): Observable<SlapStatusWizardStepDto> {
    return this.slapStatusWizardStepProxy.create(input);
  }

  updateSlapWizardSteps(input: UpdateSlapStatusWizardStepsInput): Observable<void> {
    return this.slapStatusWizardStepProxy.updateMany(input);
  }

    deleteSlapWizardStep(step: number, professionId: string, applicationType: ApplicationType): Observable<void> {
    return this.slapStatusWizardStepProxy.delete(step, professionId, applicationType);
  }

  getEhcPracticeConfiguration(professionId: string): Observable<EhcPracticeConfigurationDto> {
    return this.ehcPracticeConfigurationServiceProxy.get(professionId);
  }

  createOrUpdateEhcPracticeConfiguration(input: CreateOrUpdateEhcPracticeConfigurationInput): Observable<void> {
    return this.ehcPracticeConfigurationServiceProxy.createOrUpdate(input);
  }

  deleteEhcPracticeConfiguration(professionId: string): Observable<void> {
    return this.ehcPracticeConfigurationServiceProxy.delete(professionId);
    }

}
